import { render, staticRenderFns } from "./ResetMonitoring.vue?vue&type=template&id=7bd45f23&lang=pug"
import script from "./ResetMonitoring.vue?vue&type=script&lang=js"
export * from "./ResetMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports